import styled from '@emotion/styled';
import Button from '@app/components/Button';

export const Section = styled.div`
  margin-bottom: 32px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--solid-black);
  margin-bottom: 4px;
`;

export const SectionHelperText = styled.p`
  font-size: 14px;
  color: var(--transparent-black-600);
  margin-bottom: 16px;
`;

export const FileRowsList = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  & > *:not(:last-child) {
    margin-bottom: 8px;
  }
`;

// Standard visually-hidden pattern (not display:none) so the native file input stays focusable
// and operable by keyboard even though the styled label is what's visible.
export const VisuallyHiddenFileInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const EmptyAttachLabel = styled.label`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  padding: 10px 20px;
  border: 1px dashed var(--transparent-black-400);
  border-radius: 4px;
  color: var(--accent-blue-600);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:focus-within {
    outline: 2px solid var(--accent-blue-600);
    outline-offset: 2px;
  }
`;

export const AddMoreLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  color: var(--accent-blue-600);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:focus-within {
    outline: 2px solid var(--accent-blue-600);
    outline-offset: 2px;
  }
`;

export const FormatsHint = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: var(--transparent-black-600);
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: var(--primary-200-50-a);
  border-radius: 4px;
`;

export const FileRowIcon = styled.div`
  display: flex;
  flex-shrink: 0;
  margin-right: 10px;
`;

export const FileRowInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const FileRowNameLine = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
`;

export const FileRowName = styled.span`
  font-size: 14px;
  color: var(--solid-black);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileRowStatus = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  color: var(--transparent-black-600);
`;

export const FileRowErrorText = styled.div`
  font-size: 12px;
  color: var(--error-600);
  margin-top: 2px;
`;

export const DeleteButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 12px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`;
